export default function get_enableVue3MpClick(sensors) {
  var sa = sensors.instance;

  return function enableVue3MpClick() {




































































































  };
}
